import {disableScroll, enableScroll} from 'core/helpers';
import {TAppThunk} from 'core/redux/types';
import {actionPortalHideAll, actionSetPortalHidden, actionSetPortalVisible} from 'modules/portal/slice';
import {selectIsAnyPortalVisible} from 'modules/portal/selectors';
import {IShowModalOptions} from 'modules/modals/types';
import {MODALS} from 'modules/modals/constants';

export const showModal =
    (modalName: string, showModalOptions?: IShowModalOptions): TAppThunk<void> =>
    async (dispatch) => {
        // disableScroll безопасно вызывается несколько раз
        disableScroll();

        if (showModalOptions?.isHideAll) {
            dispatch(actionPortalHideAll());
        }

        dispatch(actionSetPortalVisible(modalName));
    };

export const hideModal =
    (modalName: string): TAppThunk<any> =>
    async (dispatch, getState) => {
        dispatch(actionSetPortalHidden(modalName));

        const state = getState();

        // получаем обновленное состояние после dispatch
        const isAnyModalVisible = selectIsAnyPortalVisible(state);

        // костыль, чтобы при первой инициализации приложения мы разблокировали скролл при закрытии поп-апа подтверждения возраста
        if (!isAnyModalVisible || state.portal?.[MODALS.CITY_CLARIFICATION.name]?.visible) {
            enableScroll();
        }
    };
